class PredictiveSearch extends window.HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector( 'input[type="search"]' );
		this.predictiveSearchResults = this.querySelector( '#predictive-search' );

		this.input.addEventListener( 'input', this.debounce( ( event ) => {
			this.onChange( event );
		}, 300 ).bind( this ) );
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if ( ! searchTerm.length ) {
			this.close();
			return;
		}

		this.getSearchResults( searchTerm );
	}

	getSearchResults(searchTerm) {
		fetch( `/search/suggest?q=${searchTerm}&resources[type]=query,product,article,page&resources[limit_scope]=all&section_id=predictive-search` )
			.then( (response) => {
				if ( ! response.ok ) {
					var error = new window.Error( response.status );
					this.close();
					throw error;
				}

				return response.text();
			} )
			.then( ( text ) => {
				const resultsMarkup = new window.DOMParser().parseFromString( text, 'text/html' ).querySelector( '#shopify-section-predictive-search' ).innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			} )
			.catch( ( error ) => {
				this.close();
				throw error;
			} );
	}

	open() {
		this.predictiveSearchResults.style.display = 'block';
	}

	close() {
		this.predictiveSearchResults.style.display = 'none';
	}

	debounce( fn, wait ) {
		let t;
		return ( ...args ) => {
			window.clearTimeout(t);
			t = window.setTimeout( () => fn.apply( this, args ), wait );
		};
	}
}

window.customElements.define( 'predictive-search', PredictiveSearch );
